// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as CityContext$PorterinFeature from "../../contexts/city-context/CityContext.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as ModalContext$PorterinFeature from "../../contexts/modal-context/ModalContext.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as GAEventsConstants$PorterinFeature from "../../shared/core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";
import * as EstimateCardModuleScss from "../styles/common/EstimateCard.module.scss";

var styles = EstimateCardModuleScss;

function EstimateCardCmp(Props) {
  var category_cards_data = Props.category_cards_data;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var fare_estimate_action = Props.fare_estimate_action;
  var modal_content = Props.modal_content;
  var modalContext = ModalContext$PorterinFeature.useModalContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: styles["estimate-card"],
              onClick: (function (param) {
                  Curry._1(modalContext.toggleModal, {
                        TAG: /* FareEstimateModal */9,
                        _0: true,
                        _1: category_cards_data,
                        _2: fare_estimate_form_content,
                        _3: modal_content
                      });
                  var currentLocale = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.next_locale);
                  PublishEventsHelper$PorterinFeature.publishEventsV2(GAEventsConstants$PorterinFeature.gaGetEstimateAction, {
                        category: citySelectedContext.category,
                        language_selected: LocaleHelpers$PorterinUtils.localeToString(currentLocale)
                      });
                  PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaGetEstimateActionV2, undefined);
                })
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: styles["estimate-text"]
                    }, fare_estimate_action.title), React.createElement("div", {
                      className: styles["estimate-subtext"]
                    }, fare_estimate_action.desc)), React.createElement("div", {
                  className: styles["icon-bg"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: fare_estimate_action.icon.path,
                      height: 15.0,
                      width: 20.0,
                      quality: 100.0,
                      alt: fare_estimate_action.icon.alt_text
                    })));
}

var make = EstimateCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
